'use client';

import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import React from 'react';
import { utilsStyles } from '../../..';
import type { VariantType } from '../../../types/variant';
import Badge from '../Badge/Badge';
import styles from './Tab.module.scss';
import raffleStyles from './Tab.raffle.module.scss';

export type TabItem = { key: string; text: string; showBadge?: boolean; url?: string };

export type TabProps = {
  tabKey: string;
  tabItems: Array<TabItem>;
  isTextBold?: boolean;
  variant?: VariantType;
};

function Tab({ tabKey, tabItems, isTextBold = false, variant = 'default' }: TabProps) {
  const router = useRouter();
  const itemWidth = 100 / tabItems.length;
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;

  const handleClick = (item: TabItem) => {
    // URLが設定されていればそちらに遷移
    if (item.url) {
      router.push(item.url as Route);
      return;
    }

    // URLを書き換える
    const params = new URLSearchParams(location.search);
    params.set('tab', item.key);
    // ページを保持してタブ遷移するパターンはなさそうなので、ページングパラメータがある場合は削除
    if (params.get('page')) {
      params.delete('page');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  return (
    <ul className={currentStyles.tabs}>
      {tabItems.map((item) => (
        <li
          className={`${isTextBold ? utilsStyles.textBold : ''} ${currentStyles.tabItem} ${
            item.key === tabKey ? currentStyles.active : currentStyles.inActive
          }`}
          style={{ width: `${itemWidth}%` }}
          key={item.key}
          onClick={() => handleClick(item)}
          data-testid={`tab-${item.key}`}
        >
          <span className={currentStyles.tabText}>
            {item.text}
            {item.showBadge && (
              <div className={currentStyles.menuBadge}>
                <Badge color='primary' />
              </div>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}

export default Tab;
